import { render, h } from 'vue';
const createElement = () => typeof document !== 'undefined' && document.createElement('div');
const mount = function (component) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    props = _ref.props,
    children = _ref.children,
    element = _ref.element,
    app = _ref.app;
  let el = element ? element : createElement();
  let vNode = h(component, props, children);
  if (app && app._context) {
    vNode.appContext = app._context;
  }
  render(vNode, el);
  const destroy = () => {
    if (el) {
      render(null, el);
    }
    el = null;
    vNode = null;
  };
  return {
    vNode,
    destroy,
    el
  };
};
export default mount;